import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '../Modal';
import {
  acceptTCAction,
  fetchTCAcceptanceStatusAction,
} from '../../actions/termsAndConditionsAction';
import { useAppConfig } from '../../utils/hooks/useAppConfig';

export const TermsModal = () => {
  const dispatch = useDispatch();
  const tcAcceptanceStatus = useSelector((state) => state.tcAcceptanceStatus);
  const acceptTc = useSelector((state) => state.acceptTc);
  const appConfig = useAppConfig();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchTCAcceptanceStatusAction(appConfig.ecCountryCode));
  }, [dispatch, appConfig.ecCountryCode]);

  useEffect(() => {
    if (tcAcceptanceStatus.data?.hasAcceptedLatest === false) {
      setIsOpen(true);
    }
  }, [tcAcceptanceStatus.data?.hasAcceptedLatest]);

  useEffect(() => {
    if (acceptTc.success) {
      setIsOpen(false);
    }
  }, [acceptTc.success]);

  const termsS3Url = tcAcceptanceStatus.data?.latest?.s3Url;

  return (
    <Modal
      confirmLabel='Accept'
      heading='We’ve updated our Venue Terms & Conditions'
      hideCancelButton
      inputStyle={{
        button: {
          backgroundColor: '#FAD14C',
          color: '#313131',
          marginLeft: 'auto',
        },
      }}
      isOpen={isOpen}
      onConfirm={() => {
        dispatch(acceptTCAction(appConfig.ecCountryCode));
      }}
      isLoading={acceptTc.pending}
      showCloseButton={false}
      inputProps={{
        sx: {
          zIndex: 99999, // note: makes sure this modal is always on top
        },
      }}
    >
      <p style={{ margin: 0 }}>
        To help us keep things running smoothly for you, we’ve made some updates to our{' '}
        <a href={termsS3Url} target='_blank' rel='noopener noreferrer'>
          Venue Terms & Conditions
        </a>
        .
      </p>
      <p style={{ margin: 0, marginTop: '16px' }}>
        Please read through the updated terms carefully before clicking accept. By clicking
        &quot;Accept,&quot; you agree to these updated terms & conditions.
      </p>
    </Modal>
  );
};
